import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExemplosComponent } from './exemplos.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    ExemplosComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    ExemplosComponent
  ]
})

export class ExemplosModule { }
